import type { BlockId } from 'src/game/minigame/match2-timestep/game/defs/block';
import { BlockGenAlgorithmDef } from 'src/game/minigame/match2-timestep/game/defs/map';

export type Region = {
  version: string;
  hash: string;
  levels: Record<string, RegionLevel>;
  blocks: BlockId[];
};

export type RegionLevel = {
  hash: string;
  data: RegionLevelData;
};

export type RegionLevelData = {
  version: string;
  level: number;
  data: string;
  blockGen?: BlockGenAlgorithmDef;
};

/**
 * The number of levels in a region.
 */
export const REGION_SIZE = 50;
